import { render } from "./PhotoAlbum.vue?vue&type=template&id=61ce2907&scoped=true"
import script from "./PhotoAlbum.vue?vue&type=script&lang=js"
export * from "./PhotoAlbum.vue?vue&type=script&lang=js"

import "./PhotoAlbum.vue?vue&type=style&index=0&id=61ce2907&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ce2907"]])

export default __exports__